import axios from '../../../../utils/AxiosUtils';
import i18n from '../../../../i18next';

import {
    LOADING,
    LOAD_DELIVERY_SETTINGS_SUCCESS,
    UPDATE_DELIVERY_SETTINGS_SUCCESS,
    RESET_DELIVERY_SETTINGS
} from '../../../types';
import MessageUtils from "../../../../utils/MessageUtils";
import { doLoadOpeningHours } from '../../../index';

export const loadDeliverySettings = (restaurantId, deliveryZoneScreenCallback) => {
    return (dispatch, getState) => {
        doLoadDeliverySettings(dispatch, getState, restaurantId, deliveryZoneScreenCallback);
    }
}

const doLoadDeliverySettings = (dispatch, getState, restaurantId, deliveryZoneScreenCallback) => {
    dispatch({ type: LOADING, payload: true });

    const url = `/settings/${restaurantId}/delivery`;

    axios().get(url)
        .then(response => {
            loadDeliverySettingsSuccess(dispatch, response, getState, restaurantId);

            if (deliveryZoneScreenCallback) {
                deliveryZoneScreenCallback();
            }
        })
        .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:deliveryActions.loadSettingsFailure')));
}

const loadDeliverySettingsSuccess = (dispatch, response, getState, restaurantId) => {
    if (response.status === 204) {
        const saveDataToScreen = 'delivery';
        doLoadOpeningHours(restaurantId, dispatch, getState, saveDataToScreen);
    }

    dispatch({ type: LOADING, payload: false });

    if (response.status !== 204) {
        dispatch({ type: LOAD_DELIVERY_SETTINGS_SUCCESS, payload: response.data });
    }
}

export const updateDeliverySettings = (restaurantId, state, callback) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/settings/${restaurantId}/delivery`;

        // Prepare delivery settings
        let deliverySettings;
        if (state.sendFromDeliveryScreen) {
            deliverySettings = {
                id: state.id,
                preparationTimes: state.preparationTimes,
                supportedTenderTypes: state.supportedTenderTypes,
                deliveryZones: state.deliveryZones,
                zoneType: state.zoneType,
                serviceNote: state.serviceNote,
                timeSlots: state.timeSlots,
                nextDayOrdersOnly: state.nextDayOrdersOnly,
                nextDayOrdersNumber: state.nextDayOrdersNumber,
                useGeneralDeliveryPartnerSettings: state.useGeneralDeliveryPartnerSettings
            };
        } else {

            deliverySettings = {
                id: state.id,
                preparationTimes: state.preparationTimes,
                supportedTenderTypes: state.supportedTenderTypes,
                deliveryZones: state.deliveryZones,
                serviceNote: getState().deliverySettings.serviceNote,
                zoneType: state.zoneType,
                serviceNote: state.serviceNote,
                timeSlots: getState().deliverySettings.timeSlots,
                nextDayOrdersOnly: state.nextDayOrdersOnly,
                nextDayOrdersNumber: state.nextDayOrdersNumber
            };
        }

        axios().post(url, deliverySettings)
            .then(response => updateDeliverySettingsSuccess(dispatch, getState, response, restaurantId, callback))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.saveFailure')));
    }
}

const updateDeliverySettingsSuccess = (dispatch, getState, response, restaurantId, callback) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: UPDATE_DELIVERY_SETTINGS_SUCCESS, payload: response.data });

    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.saveSuccess'));
    if (callback) {
        callback();
    }
    resetDeliverySettings(dispatch);
    doLoadDeliverySettings(dispatch, getState, restaurantId);

}

export const resetDeliverySettings = (dispatch) => {
    return (dispatch) => {
        dispatch({ type: RESET_DELIVERY_SETTINGS });
    }
};


// WEBPACK FOOTER //
// ./src/actions/restaurants/settings/service/DeliveryActions.js